// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { FrontendErrorRequestDto } from '../models';
/**
 * FrontendErrorsApi - axios parameter creator
 */
export const FrontendErrorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Report a frontend error
         * @param {FrontendErrorRequestDto} frontendErrorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportFrontendError: async (frontendErrorRequestDto: FrontendErrorRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frontendErrorRequestDto' is not null or undefined
            assertParamExists('reportFrontendError', 'frontendErrorRequestDto', frontendErrorRequestDto)
            const localVarPath = `/api/v1/frontend-errors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(frontendErrorRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrontendErrorsApi - functional programming interface
 */
export const FrontendErrorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrontendErrorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Report a frontend error
         * @param {FrontendErrorRequestDto} frontendErrorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportFrontendError(frontendErrorRequestDto: FrontendErrorRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportFrontendError(frontendErrorRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FrontendErrorsApi.reportFrontendError']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FrontendErrorsApi - factory interface
 */
export const FrontendErrorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrontendErrorsApiFp(configuration)
    return {
        /**
         * 
         * @summary Report a frontend error
         * @param {FrontendErrorRequestDto} frontendErrorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportFrontendError(frontendErrorRequestDto: FrontendErrorRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportFrontendError(frontendErrorRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FrontendErrorsApi - interface
 */
export interface FrontendErrorsApiInterface {
    /**
     * 
     * @summary Report a frontend error
     * @param {FrontendErrorRequestDto} frontendErrorRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportFrontendError(frontendErrorRequestDto: FrontendErrorRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * FrontendErrorsApi - object-oriented interface
 */
export class FrontendErrorsApi extends BaseAPI implements FrontendErrorsApiInterface {
    /**
     * 
     * @summary Report a frontend error
     * @param {FrontendErrorRequestDto} frontendErrorRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportFrontendError(frontendErrorRequestDto: FrontendErrorRequestDto, options?: RawAxiosRequestConfig) {
        return FrontendErrorsApiFp(this.configuration).reportFrontendError(frontendErrorRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

